import { useTranslation } from 'react-i18next';
import ErrorBoundary from 'src/components/ErrorBoundary';
import Navbar from 'src/components/NavBar';
import useWindowSize from 'src/hooks/useWindowSize';
import { ViewCatalogsContextProvider } from 'src/sections/view-catalogs/ViewCatalogsContext';
import ViewCatalogsFilters from 'src/sections/view-catalogs/ViewCatalogsFilters';
import ViewCatalogsGridView from 'src/sections/view-catalogs/ViewCatalogsGridView';
import 'src/style/view-catalogs/ViewCatalogs.scss';

const ViewCatalogs = () => {
  const { t } = useTranslation();
  const { height } = useWindowSize();

  return (
    <ErrorBoundary>
      <ViewCatalogsContextProvider>
        <div
          data-testid="view-catalogs-page"
          className="view-catalogs-layout"
          style={{ height: `${height}px` }}
        >
          <div className="mb-2 min-h-0 bg-white" style={{ gridArea: 'navbar' }}>
            <Navbar title={t('Browse Catalogs')} />
            <ViewCatalogsFilters />
          </div>
          <div
            className="flex h-full min-h-0 w-full flex-col overflow-hidden"
            style={{ gridArea: 'main' }}
          >
            <ViewCatalogsGridView />
          </div>
        </div>
      </ViewCatalogsContextProvider>
    </ErrorBoundary>
  );
};

export default ViewCatalogs;
